import * as fragments from './fragments'

export const accordion = groq`
  _type == 'accordion' => {
    _type,
    'id': _key,
    items[] {
      title,
      'content': ${fragments.portableText},
    }
  }
`

export const hero = groq`{
    title,
    subtitle,
   ${fragments.media},
    'theme': theming->handle.current,

  }
`

export const areaHero = groq`
  hero {
    'theme': theming->handle.current,
    'polygon': ^.polygon,
    showDynamicNumbers,
    title,
    subtitle,
    svgIcon,
    geopoint,
   ${fragments.media},
   items[] {
    _key, 
    title,
    info,
    suffix
   }
  }
`

export const impactText = groq`
  _type == 'impact-text' => {
    _type,
    'id': _key,
    title,
    text,
    ${fragments.portableText},
  }
`
export const introduction = groq`
  _type == 'introduction' => {
    _type,
    'id': _key,
    title,
    ${fragments.portableText},
  }
`

export const mediaCardsCarousel = groq`
  _type == "mediaCardsCarousel" => {
    title,
    mediaCards[]{
      ${fragments.mediaCard},
    },
  }
`
export const educationGrid = groq`
  _type == "educationGrid" => {
    title,
    bigTitle,
    speechBubble{
      text,
      svg,
      color{
        background,
        text
      },
    },
    educationCards[]{
      ${fragments.educationCard},
    },
  }
`
export const speciesCarousel = groq`
  _type == "speciesCarousel" => {
    title,
    ${fragments.portableText},
    'items': items[]{
      ${fragments.specie}
    }
  }
`
export const contentGrid = groq`
  _type == "contentGrid" => {
    title,
    text,
    socialMediaEvents[] {
      ${fragments.socialMediaCard},
    },
    pages[]{
       ${fragments.page},
    },
      callToAction[]{
      ${fragments.link}
    },
  }
`
export const educationPageGrid = groq`
  _type == "educationPageGrid" => {
    title,
    text,
    pages[]{
       ${fragments.page},
    },
  }
`
export const articlesOverview = groq`
  _type == "articlesOverview" => {
    title,
    text,
    amountToShow,
    socialMediaEvents[] {
      ${fragments.socialMediaCard},
    },
      callToAction[]{
      ${fragments.link}
    },
  }
`

export const stepContent = groq`
  _type == "stepContent" => {
      title,
      steps[]{
        title,
        subTitle,
        text,
        callToAction[]{
        ${fragments.link}
    },
        ${fragments.media},
      },
  }
`
export const featuredSpecies = groq`
  _type == "featuredSpecies" => {
      title,
      'items': items[]{
      ${fragments.specie},
    },
  }
`
export const downloads = groq`
  _type == "downloads" => {
      title,
      text,
      downloads[]{
        title,
      'text':${fragments.portableText},
        downloadLabel,
        "file": file.asset->url,
        ${fragments.media},
      },
  }
`
export const featureLinkList = groq`
  _type == "feature-link-list" => {
    title,
    text,
    links[] {
      ${fragments.link}
    },
  }
`
export const ctaMedia = groq`
  _type == "ctaMedia" => {
    title,
    subTitle,
    text,
    layout,
    callToActions[]{
        ${fragments.link}
    },
    person{...${fragments.person}},
   ${fragments.media}
  }
`

export const partners = groq`
  _type == "partners" => {
    title,
    partners[] {
    ${fragments.partner}
    },
  }
`

export const supportingText = groq`
  _type == "supporting-text" => {
    title,
    ${fragments.portableText}

  
  }
`
export const contentCardCarousel = groq`
  _type == "contentCardCarousel" => {
    title,
    ${fragments.portableText},
    cards[]{
       title,
       ${fragments.media},
       text,
       portableTextSimple[]{
      ...${fragments.portableTextSimple}
    },
       color,
      callToAction[]{
      ${fragments.link}
    },
    },
  }
`

export const mediaSection = groq`
  _type == "mediaSection" => {
   placement,
   ${fragments.media},
   showVideoControls,
   containFullImage
  }
`

export const peopleGrid = groq`
  _type == "peopleGrid" => {
    type,
    title,
    'people': people[]{...${fragments.person}},
    }
`
export const gallery = groq`
  _type == "gallery" => {
    medias[]{
      image {
    ...,
    caption,
    ...asset-> {
    altText,
    ...metadata {
      lqip, // the lqip can be used for blurHashUrl or other low-quality placeholders
      ...dimensions {
        width,
        height
      }
    }
  }
  },
    video {
      asset-> {
        playbackId,
        assetId,
        filename
      }
    },
    }
  }
`
export const socialMediaCarousel = groq`
  _type == "socialMediaCarousel" => {
    title,
    text,
    socialMediaCards[]{
      ${fragments.socialMediaCard},
    },
    showSocialMediaTags,
  }
`

export const informationItems = groq`
  _type == "information-items" => {
    trumpet,
    title,
    ${fragments.portableText},
    callToAction[]{
      ${fragments.link}
    },
    items[] {
      _key, 
      title,
      info,
      suffix
   },
   useDynamicNumbers,
   "polygon": relatedArea->polygon
  }
`

export const address = groq`
  _type == "address" => {
    title,
    "media": image,
    ${fragments.portableText},
    'address': text[]{
      ...${fragments.portableTextSimple}
    },
  }
`

export const textSection = groq`
  _type == "textSection" => {
    items[] {
      _key,
      title,
      ${fragments.portableText},
    }
  }
`

export const speciesSummary = groq`
  _type == "species-summary" => {
    'polygon': area->polygon,
    itemAllSpecies{
      title,
      ${fragments.portableText},
    }, 
    itemRedlistedSpecies{
      title,
      ${fragments.portableText},
    }, 
    ctaLabel,
    callToAction[]{
      ${fragments.link}
    },
  }
`
export const speciesLiveFeed = groq`
  _type == "species-live-feed" => {
    'polygon': area->polygon,
    trumpet, 
    title, 
  }
`

export const speciesGroupsSummary = groq`
  _type == "species-groups-summary" => {
    'polygon': area->polygon,
    title, 
    ctaLabel,
    callToAction[]{
      ${fragments.link}
    },
  }
`
export const timeline = groq`
  _type == "timeline" => {
    steps[]{
      title,
      year,
      text,
      ${fragments.media},
    },
  }
`

// Page sections query
export const builder = groq`
  pageSections[] {
    _type,
    'id': _key,
    'theme': theming->handle.current,
    'data': {
      ${impactText},
      ${mediaCardsCarousel},
      ${educationGrid},
      ${speciesCarousel},
      ${contentGrid},
      ${articlesOverview},
      ${stepContent},
      ${featuredSpecies},
      ${featureLinkList},
      ${socialMediaCarousel},
      ${ctaMedia},
      ${mediaSection},
      ${partners},
      ${downloads},
      ${supportingText},
      ${contentCardCarousel},
      ${educationPageGrid},
      ${peopleGrid},
      ${gallery},
      ${accordion},
      ${informationItems},
      ${address},
      ${introduction},
      ${textSection},
      ${speciesSummary},
      ${speciesLiveFeed},
      ${speciesGroupsSummary},
      ${timeline},
    }
  }
`
